.flex {
  --flex-margin-horizontal: initial;
  --flex-margin-vertical: initial;
  --flex-padding-horizontal: initial;
  --flex-padding-vertical: initial;

  margin-block: var(--flex-margin-vertical);
  margin-inline: var(--flex-margin-horizontal);
  padding-block: var(--flex-padding-vertical);
  padding-inline: var(--flex-padding-horizontal);
}
